import { fetchGraphQl } from '../utils/fetchGraphQl';
import { userHasService } from '@orientaction/utils';

const useOAMatch = () => {
  const signupToOAMatch = async (user: any) => {
    let userType;
    if (user.company_user_role.id === 5) {
      if (userHasService(user, 1)) userType = 'bilan_competences';
      else if (userHasService(user, 5) || !user?.rattachement) userType = 'reconversion_pro';
    } else userType = 'consultant';
    if (!userType) {
      const error = new Error('Not allowed to match')
      console.error(error);
      throw error;
    }
    const data = {
      query: `
        mutation AddExternUser(
          $userIdOa: ID!
          $firstName: String!
          $lastName: String!
          $email: String!
          $sex: AllowedSex!
          $login: String!
          $userType: AllowedUserType!
        ) {
          addExternUser(
            userIdOA: $userIdOa
            firstName: $firstName
            lastName: $lastName
            email: $email
            sex: $sex
            login: $login
            userType: $userType 
          ) {
            message
            result {
              id
              firstName
            }
            code
            success
          }
        }
      `,
      variables: {
        userIdOa: user.id,
        firstName: user.firstname,
        lastName: user.lastname,
        email: user.email,
        login: user.username,
        userType,
        sex: user.gender === 'homme' ? 'male' : 'female',
      },
    };
    const resp = await fetchGraphQl(data);
    return resp;
  };

  const verifyUser = async (idUser: any) => {
    const data = {
      query: `
        query Users($filter: FilterUser) {
          users(filter: $filter) {
            code
            success
            result {
              id
              userIdOA
            }
          }
        }
      `,
      variables: {
        filter: {
          field: 'userIdOA',
          operator: 'EQUAL',
          value: idUser,
        },
      },
    };
    const resp = await fetchGraphQl(data);
    return resp.data.users.result.length > 0;
  };

  const getUserByUserIdOA = async (userIdOA: number) => {
    const data = {
      query: `
        query Users($filter: FilterUser) {
          users(filter: $filter) {
            code
            success
            result {
              id
              email
              userIdOA
              subNetworks {
              id
              name
              }
            }
          }
        }
      `,
      variables: {
        filter: {
          field: 'userIdOA',
          operator: 'EQUAL',
          value: userIdOA?.toString(),
        },
      },
    };

    try {
      const resp = await fetchGraphQl(data);

      return resp.data?.users?.result?.[0] || null;
    } catch (err) {
      console.error(err);
    }
  };

  const deleteUserFromSubNetwork = async (userId: number, subNetworkId: any) => {
    const data = {
      query: `
        mutation Mutation($userId: ID!, $subNetworkId: ID!) {
          deleteUserToSubNetwork(userId: $userId, subNetworkId: $subNetworkId)
        }
      `,
      variables: {
        userId,
        subNetworkId,
      },
    };

    try {
      const response = await fetchGraphQl(data);

      return response?.data?.deleteUserToSubNetwork;
    } catch (err) {
      console.error(err);
    }
  };

  const fetchSubNetworks = async () => {
    const data = {
      query: `
        query SubNetworks {
          subNetworks {
            result {
              id
              name
            }
          }
        }
      `,
    };

    try {
      const response = await fetchGraphQl(data);

      const json = await response.json();

      if (json.errors) {
        return console.error(json.errors);
      }

      return json.data.subNetworks.result;
    } catch (err) {
      console.error(err);
    }
  };

  const updateExternUser = async (id: number, payload: any) => {
    const data = {
      query: `
      mutation UpdateExternUser(
        $updateExternUserId: ID!
        $firstName: String
        $lastName: String
        $email: String
        $sex: AllowedSex
        $job: String
        $entreprise: String
        $birthDate: Date
        $picture: String
        $city: String
        $postalCode: String
        $diploma: String
        $login: String
        $userType: AllowedUserType
      ) {
        updateExternUser(
          id: $updateExternUserId
          firstName: $firstName
          lastName: $lastName
          email: $email
          sex: $sex
          login: $login
          job: $job
          entreprise: $entreprise
          postalCode: $postalCode
          city: $city
          diploma: $diploma
          birthDate: $birthDate
          picture: $picture
          userType: $userType
        ) {
          result {
            id
            email
            role {
              id
              name
            }
          }
        }
      }
    `,
      variables: {
        updateExternUserId: id.toString(),
        ...payload,
      },
    };

    try {
      const response = await fetchGraphQl(data);

      return response?.data?.updateExternUser;
    } catch (err) {
      console.error(err);
    }
  };

  const deleteAllSubNetwork = async (idUser: number) => {
    const user = await getUserByUserIdOA(idUser);
    if (!user) {
      return false;
    }
    user.subNetworks.forEach((subnetwork: any) => {
      deleteUserFromSubNetwork(user.id, subnetwork.id);
    });
    return true;
  };

  return {
    signupToOAMatch,
    verifyUser,
    deleteAllSubNetwork,
    updateExternUser,
    getUserByUserIdOA
  };
};

export default useOAMatch;
